import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiUrls } from '../../config/api-urls/api-urls';
import { MainService } from '../../provider/main.service';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html'
})
export class ForgotPasswordComponent implements OnInit {

  form: FormGroup | any;
  resetId: any;

  constructor(private router: Router, public mainService: MainService) { }

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', Validators.compose([Validators.required, Validators.pattern(/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})+$/)]))
    })
  }

  get f() { return this.form.controls }

  submit() {
    if (this.form.valid) {
      const data = {
        email: this.form.value.email
      }
      this.mainService.showSpinner()
      this.mainService.postApi(ApiUrls.forgotPassword, data, 0).subscribe((res: any) => {
        if (res.responseCode == 200) {
          this.mainService.hideSpinner()
          this.mainService.successToast(res.responseMessage)
          this.resetId = res.result;
          this.form.reset();
          this.router.navigate(['otp/' + this.resetId])
        } else {
          this.mainService.hideSpinner()
          this.mainService.errorToast(res.responseMessage)
        }
      })
    }
    else {
      this.mainService.errorToast('Email is required.');
    }

  }
}
